'use strict';
app.factory('authService', ['$http', '$q', '$rootScope', 'localStorageService', 'ngAuthSettings', 'userService', function ($http, $q, $rootScope, localStorageService, ngAuthSettings, userService) {

    var serviceBase = ngAuthSettings.apiServiceBaseUri;
    var authServiceFactory = {};

    var _authentication = {
        isAuth: false,
        userName: "",
        isAdmin: false,
        isConfigurator: false,
        isMaintenanceAdmin: false,
        useRefreshTokens: false
    };

    var _externalAuthData = {
        provider: "",
        userName: "",
        externalAccessToken: ""
    };

    var _createLocalStorageObject = function(tokenResponse) {
        var localStorageData = new warsApp.models.User();
        localStorageData.token = tokenResponse.access_token;
            localStorageData.userId = tokenResponse.userId;
            localStorageData.userName = tokenResponse.userName;
            localStorageData.emailAddress = tokenResponse.emailAddress;
            localStorageData.firstName = tokenResponse.firstName;
            localStorageData.lastName = tokenResponse.lastName;
            localStorageData.imageUrl = tokenResponse.imageUrl;
            localStorageData.expires = tokenResponse[".expires"];
            localStorageData.isAdmin = tokenResponse.isAdmin;
            localStorageData.isConfigurator = tokenResponse.isConfigurator;
            localStorageData.isMaintenanceAdmin = tokenResponse.isMaintenanceAdmin;
        return localStorageData;
    }

    var _logOut = function () {
        localStorageService.remove('authorizationData');
        _authentication.isAuth = false;
        _authentication.isAdmin = false;
        _authentication.isConfigurator = false;
        _authentication.isMaintenanceAdmin = false;
        _authentication.userName = "";
        _authentication.useRefreshTokens = false;
        $rootScope.$broadcast("logOut");
    };

    var _fillAuthData = function () {
        var authData = localStorageService.get('authorizationData');
        if (authData) {
            _authentication.isAuth = true;
            _authentication.isAdmin = authData.isAdmin;
            _authentication.isConfigurator = authData.isConfigurator;
            _authentication.isMaintenanceAdmin = authData.isMaintenanceAdmin;
            _authentication.userName = authData.userName;
            _authentication.useRefreshTokens = authData.useRefreshTokens;
            userService.setLoggedInUserId(authData.userId);
        }
    };

    var _providerLogin = function (token) {
        _logOut();
        var localStorageData = _createLocalStorageObject(token);
        localStorageData.refreshToken = "";
        localStorageData.useRefreshTokens = false;
        localStorageService.set('authorizationData', localStorageData);
        _authentication.isAuth = true;
        _authentication.isAdmin = token.isAdmin;
        _authentication.isConfigurator = token.isConfigurator;
        _authentication.isMaintenanceAdmin = token.isMaintenanceAdmin;
        _authentication.userName = token.userName;
        _authentication.useRefreshTokens = false;
        userService.setLoggedInUserId(token.userId);
        //_fillAuthData();
    }

    var _refreshToken = function () {
        var deferred = $q.defer();

        var authData = localStorageService.get('authorizationData');

        if (authData) {

            if (authData.useRefreshTokens) {

                var data = "grant_type=refresh_token&refresh_token=" + authData.refreshToken + "&client_id=" + ngAuthSettings.clientId;

                localStorageService.remove('authorizationData');

                $http.post(serviceBase + 'token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).success(function (response) {

                    var localStorageData = _createLocalStorageObject(response);

                    localStorageData.refreshToken = response.refresh_token;
                    localStorageData.useRefreshTokens = true;

                    localStorageService.set('authorizationData', localStorageData);

                    deferred.resolve(response);

                }).error(function (err, status) {
                    _logOut();
                    deferred.reject(err);
                });
            }
        }

        return deferred.promise;
    };

    var _obtainAccessToken = function (externalData) {

        var deferred = $q.defer();

        $http.get(serviceBase + 'api/account/ObtainLocalAccessToken', { params: { provider: externalData.provider, externalAccessToken: externalData.externalAccessToken } }).success(function (response) {

            var localStorageData = _createLocalStorageObject(response);

            localStorageData.refreshToken = "";
            localStorageData.useRefreshTokens = false;

            localStorageService.set('authorizationData', localStorageData);

            _authentication.isAuth = true;
            _authentication.isAdmin = response.isAdmin;
            _authentication.isConfigurator = response.isConfigurator;
            _authentication.isMaintenanceAdmin = response.isMaintenanceAdmin;
            _authentication.userName = response.userName;
            _authentication.useRefreshTokens = false;
            userService.setLoggedInUserId(response.userId);

            deferred.resolve(response);

        }).error(function (err, status) {
            _logOut();
            deferred.reject(err);
        });

        return deferred.promise;
    };

    var _registerExternal = function (registerExternalData) {

        var deferred = $q.defer();

        $http.post(serviceBase + 'api/account/registerexternal', registerExternalData).success(function (response) {

            var localStorageData = _createLocalStorageObject(response);

            localStorageData.refreshToken = "";
            localStorageData.useRefreshTokens = false;

            localStorageService.set('authorizationData', localStorageData);

            _authentication.isAuth = true;
            _authentication.isAdmin = response.isAdmin;
            _authentication.isConfigurator = response.isConfigurator;
            _authentication.isMaintenanceAdmin = response.isMaintenanceAdmin;
            _authentication.userName = response.userName;
            _authentication.useRefreshTokens = false;
            userService.setLoggedInUserId(response.userId);

            deferred.resolve(response);

        }).error(function (err, status) {
            _logOut();
            deferred.reject(err);
        });

        return deferred.promise;

    };

    // TODO: Remove this when done testing without internet
    var _obtainAccessTokenAutoSignInAsCody = function () {
        var deferred = $q.defer();

        $http.get(serviceBase + 'api/account/ObtainLocalAccessTokenAutoSignInAsCody').success(
            function (response) {

                var localStorageData = _createLocalStorageObject(response);

                localStorageData.refreshToken = "";
                localStorageData.useRefreshTokens = false;

                localStorageService.set('authorizationData', localStorageData);

                _authentication.isAuth = true;
                _authentication.isAdmin = response.isAdmin;
                _authentication.isConfigurator = response.isConfigurator;
                _authentication.isMaintenanceAdmin = response.isMaintenanceAdmin;
                _authentication.userName = response.userName;
                _authentication.useRefreshTokens = false;
                userService.setLoggedInUserId(response.userId);
                
                deferred.resolve(response);
            }
        ).error(function (err, status) {
            _logOut();
            deferred.reject(err);
        });

        return deferred.promise;
    }

    var _redirectUrl = undefined;

    authServiceFactory.logOut = _logOut;
    authServiceFactory.fillAuthData = _fillAuthData;
    authServiceFactory.authentication = _authentication;
    authServiceFactory.refreshToken = _refreshToken;
    authServiceFactory.obtainAccessToken = _obtainAccessToken;
    // TODO: Remove this when done testing without internet
    //authServiceFactory.obtainAccessTokenAutoSignInAsCody = _obtainAccessTokenAutoSignInAsCody;
    authServiceFactory.externalAuthData = _externalAuthData;
    authServiceFactory.registerExternal = _registerExternal;
    authServiceFactory.redirectUrl = _redirectUrl;
    authServiceFactory.providerLogin = _providerLogin;

    return authServiceFactory;
}]);